export const SignIn = async (data) => {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  };
  try {
    let response = await fetch(
      `${process.env.REACT_APP_USER_API_CLOUD_ENDPOINT}/register`,
      requestOptions
    );
    const isJson = response.headers
      .get("content-type")
      ?.includes("application/json");
    const data = isJson && (await response.json());
    if (response.status === 200) {
      return { res: data, error: null };
    } else {
      return { res: null, error: data };
    }
  } catch (error) {
    console.error("There was an error!", error);
    return { res: null, error: error };
  }
};

export const LogIn = async (data) => {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  };
  try {
    let response = await fetch(
      `${process.env.REACT_APP_USER_API_CLOUD_ENDPOINT}/login`,
      requestOptions
    );
    const isJson = response.headers
      .get("content-type")
      ?.includes("application/json");
    const data = isJson && (await response.json());
    console.log(response, data);
    if (response.status === 200) {
      return { res: data, error: null };
    } else {
      return { res: null, error: data };
    }
  } catch (error) {
    console.error("There was an error!", error);
    return { res: null, error: error };
  }
};

export const forgotPassword = async (data) => {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  };
  try {
    let response = await fetch(
      `${process.env.REACT_APP_USER_API_CLOUD_ENDPOINT}/forgot-password`,
      requestOptions
    );
    const isJson = response.headers
      .get("content-type")
      ?.includes("application/json");
    const data = isJson && (await response.json());
    console.log(response, data);
    if (response.status === 200) {
      return { res: data, error: null };
    } else {
      return { res: null, error: data };
    }
  } catch (error) {
    console.error("There was an error!", error);
    return { res: null, error: error };
  }
};

export const resetPassword = async (data) => {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  };
  try {
    let response = await fetch(
      `${process.env.REACT_APP_USER_API_CLOUD_ENDPOINT}/reset-password`,
      requestOptions
    );
    const isJson = response.headers
      .get("content-type")
      ?.includes("application/json");
    const data = isJson && (await response.json());
    console.log(response, data);
    if (response.status === 200) {
      return { res: data, error: null };
    } else {
      return { res: null, error: data };
    }
  } catch (error) {
    console.error("There was an error!", error);
    return { res: null, error: error };
  }
};

export const changePassword = async (data) => {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${data.authToken}`,
    },
    body: JSON.stringify(data),
  };
  try {
    let response = await fetch(
      `${process.env.REACT_APP_USER_API_CLOUD_ENDPOINT}/user/change-password`,
      requestOptions
    );
    const isJson = response.headers
      .get("content-type")
      ?.includes("application/json");
    const data = isJson && (await response.json());
    console.log(response, data);
    if (response.status === 200) {
      return { res: data, error: null };
    } else {
      return { res: null, error: data };
    }
  } catch (error) {
    console.error("There was an error!", error);
    return { res: null, error: error };
  }
};

export const getProfile = async (data, { signal } = {}) => {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${data}`,
    },
  };
  try {
    let response = await fetch(
      `${process.env.REACT_APP_USER_API_CLOUD_ENDPOINT}/get-my-profile`,
      requestOptions,
      { signal }
    );
    const isJson = response.headers
      .get("content-type")
      ?.includes("application/json");
    const data = isJson && (await response.json());
    // console.log(response,data);
    if (response.status === 200) {
      return { res: data, error: null };
    } else {
      return { res: null, error: data };
    }
  } catch (error) {
    console.error("There was an error!", error);
    return { res: null, error: error };
  }
};

export const updateProfile = async (data, authToken) => {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
    body: JSON.stringify(data),
  };
  try {
    let response = await fetch(
      `${process.env.REACT_APP_USER_API_CLOUD_ENDPOINT}/update-my-profile`,
      requestOptions
    );
    const isJson = response.headers
      .get("content-type")
      ?.includes("application/json");
    const data = isJson && (await response.json());
    console.log(response, data);
    if (response.status === 200) {
      return { res: data, error: null };
    } else {
      return { res: null, error: data };
    }
  } catch (error) {
    console.error("There was an error!", error);
    return { res: null, error: error };
  }
};

export const updateProfilePicture = async (formData) => {
  const authToken = localStorage.getItem("authToken");

  const requestOptions = {
    method: "POST",
    headers: { Authorization: `Bearer ${authToken}` },
    body: formData,
  };

  try {
    let response = await fetch(
      `${process.env.REACT_APP_USER_API_CLOUD_ENDPOINT}/update-my-profile-pic`,
      requestOptions
    );
    const isJson = response.headers
      .get("content-type")
      ?.includes("application/json");
    const data = isJson && (await response.json());
    console.log(response, data);
    if (response.status === 200) {
      return { res: data, error: null };
    } else {
      return { res: null, error: data };
    }
  } catch (error) {
    console.error("There was an error!", error);
    return { res: null, error: error };
  }
};

export const deleteInvoices = async (data, authToken) => {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${authToken}`,
    },
    body: JSON.stringify(data),
  };
  try {
    let response = await fetch(
      `${process.env.REACT_APP_USER_API_CLOUD_ENDPOINT}/invoices/bulk-delete`,
      requestOptions
    );
    const isJson = response.headers
      .get("content-type")
      ?.includes("application/json");
    const data = isJson && (await response.json());
    console.log(response, data);
    if (response.status === 202) {
      return { res: data, error: null };
    } else {
      return { res: null, error: data };
    }
  } catch (error) {
    console.error("There was an error!", error);
    return { res: null, error: error };
  }
};

export const getTasks = async (data) => {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${data}`,
    },
  };
  try {
    let response = await fetch(
      `${process.env.REACT_APP_USER_API_CLOUD_ENDPOINT}/tasks`,
      requestOptions
    );
    const isJson = response.headers
      .get("content-type")
      ?.includes("application/json");
    const data = isJson && (await response.json());
    // console.log(response,data);
    if (response.status === 200) {
      return { res: data, error: null };
    } else {
      return { res: null, error: data };
    }
  } catch (error) {
    console.error("There was an error!", error);
    return { res: null, error: error };
  }
};

export const getTasksByStatus = async (data) => {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${data}`,
    },
  };
  try {
    let response = await fetch(
      `${process.env.REACT_APP_USER_API_CLOUD_ENDPOINT}/tasks/by-status-and-date`,
      requestOptions
    );
    const isJson = response.headers
      .get("content-type")
      ?.includes("application/json");
    const data = isJson && (await response.json());
    // console.log(response,data);
    if (response.status === 200) {
      return { res: data, error: null };
    } else {
      return { res: null, error: data };
    }
  } catch (error) {
    console.error("There was an error!", error);
    return { res: null, error: error };
  }
};

export const createTask = async (data) => {
  const authToken = localStorage.getItem("authToken");
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${authToken}`,
    },
    body: JSON.stringify(data),
  };
  try {
    let response = await fetch(
      `${process.env.REACT_APP_USER_API_CLOUD_ENDPOINT}/v2/tasks`,
      requestOptions
    );
    const isJson = response.headers
      .get("content-type")
      ?.includes("application/json");
    const data = isJson && (await response.json());
    // console.log(response,data);
    if (response.status === 201) {
      return { res: data, error: null };
    } else {
      return { res: null, error: data };
    }
  } catch (error) {
    console.error("There was an error!", error);
    return { res: null, error: error };
  }
};

export const updateTask = async (data, taskId) => {
  const authToken = localStorage.getItem("authToken");
  const requestOptions = {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${authToken}`,
    },
    body: JSON.stringify(data.updatedTask),
  };
  console.log("request options: ", data, requestOptions);
  try {
    let response = await fetch(
      `${process.env.REACT_APP_USER_API_CLOUD_ENDPOINT}/v2/tasks/${taskId}`,
      requestOptions
    );
    const isJson = response.headers
      .get("content-type")
      ?.includes("application/json");
    const data = isJson && (await response.json());
    // console.log(response,data);
    if (response.status === 200) {
      return { res: data, error: null };
    } else {
      return { res: null, error: data };
    }
  } catch (error) {
    console.error("There was an error!", error);
    return { res: null, error: error };
  }
};

export const getJobIds = async (data) => {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${data}`,
    },
  };
  try {
    let response = await fetch(
      `${process.env.REACT_APP_USER_API_CLOUD_ENDPOINT}/jobs/ids`,
      requestOptions
    );
    const isJson = response.headers
      .get("content-type")
      ?.includes("application/json");
    const data = isJson && (await response.json());
    // console.log(response,data);
    if (response.status === 200) {
      return { res: data, error: null };
    } else {
      return { res: null, error: data };
    }
  } catch (error) {
    console.error("There was an error!", error);
    return { res: null, error: error };
  }
};

export const getUserByRole = async (data) => {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${data}`,
    },
  };
  try {
    let response = await fetch(
      `${process.env.REACT_APP_USER_API_CLOUD_ENDPOINT}/users/role/assignee`,
      requestOptions
    );
    const isJson = response.headers
      .get("content-type")
      ?.includes("application/json");
    const data = isJson && (await response.json());
    // console.log(response,data);
    if (response.status === 200) {
      return { res: data, error: null };
    } else {
      return { res: null, error: data };
    }
  } catch (error) {
    console.error("There was an error!", error);
    return { res: null, error: error };
  }
};

export const getDashboardSummary = async (data) => {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${data}`,
    },
  };
  try {
    let response = await fetch(
      `${process.env.REACT_APP_USER_API_CLOUD_ENDPOINT}/dashboard/summary`,
      requestOptions
    );
    const isJson = response.headers
      .get("content-type")
      ?.includes("application/json");
    const data = isJson && (await response.json());
    console.log(response, data);
    if (response.status === 200) {
      return { res: data, error: null };
    } else {
      return { res: null, error: data };
    }
  } catch (error) {
    console.error("There was an error!", error);
    return { res: null, error: error };
  }
};

export const getJobs = async (page, type='job') => {
  const authToken = localStorage.getItem("authToken");
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${authToken}`,
    },
  };
  try {
    let response = await fetch(
      `${process.env.REACT_APP_USER_API_CLOUD_ENDPOINT}/v2/jobs?page=${page}&type=${type}`,
      requestOptions
    );
    const isJson = response.headers
      .get("content-type")
      ?.includes("application/json");
    const data = isJson && (await response.json());
    if (response.status === 200) {
      return { res: data, error: null };
    } else {
      return { res: null, error: data };
    }
  } catch (error) {
    console.error("There was an error!", error);
    return { res: null, error: error };
  }
};

export const getTimelineJobs = async (
  start_date,
  end_date,
  status = "",
  signal = null
) => {
  const authToken = localStorage.getItem("authToken");
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${authToken}`,
    },
    signal, // Attach the signal to allow request cancellation
  };

  try {
    let url = `${process.env.REACT_APP_USER_API_CLOUD_ENDPOINT}/v2/jobs/timeline?start_date=${start_date}&end_date=${end_date}`;
    if (status) {
      url += `&status=${status}`;
    }

    let response = await fetch(url, requestOptions);

    const isJson = response.headers
      .get("content-type")
      ?.includes("application/json");
    const data = isJson && (await response.json());
    console.log(response, data);

    if (response.status === 200) {
      return { res: data, error: null };
    } else {
      return { res: null, error: data };
    }
  } catch (error) {
    console.error("There was an error!", error);
    return { res: null, error };
  }
};

export const getSingleJob = async (id) => {
  const authToken = localStorage.getItem("authToken");
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${authToken}`,
    },
  };
  try {
    let response = await fetch(
      `${process.env.REACT_APP_USER_API_CLOUD_ENDPOINT}/v2/job/${id}`,
      requestOptions
    );
    const isJson = response.headers
      .get("content-type")
      ?.includes("application/json");
    const data = isJson && (await response.json());
    // console.log(response,data);
    if (response.status === 200) {
      return { res: data, error: null };
    } else {
      return { res: null, error: data };
    }
  } catch (error) {
    console.error("There was an error!", error);
    return { res: null, error: error };
  }
};

export const getJobByNum = async (id) => {
  const authToken = localStorage.getItem("authToken");
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${authToken}`,
    },
  };
  try {
    let response = await fetch(
      `${process.env.REACT_APP_USER_API_CLOUD_ENDPOINT}/v2/jobbynumber/${id}`,
      requestOptions
    );
    const isJson = response.headers
      .get("content-type")
      ?.includes("application/json");
    const data = isJson && (await response.json());
    // console.log(response,data);
    if (response.status === 200) {
      return { res: data, error: null };
    } else {
      return { res: null, error: data };
    }
  } catch (error) {
    console.error("There was an error!", error);
    return { res: null, error: error };
  }
};

// export const getTasksByUser = async (reqData = {}, status = ['in-progress', 'not-started']) => {
//   const authToken = localStorage.getItem("authToken");
//   const requestOptions = {
//     method: "GET",
//     headers: {
//       "Content-Type": "application/json",
//       Accept: "application/json",
//       Authorization: `Bearer ${authToken}`,
//     },
//   };

//   try {
//     let url = `${process.env.REACT_APP_USER_API_CLOUD_ENDPOINT}/v2/user/tasks?sort=due_date`;

//     console.log("Requesting tasks with params:", reqData);

//     // Convert reqData into query parameters manually
//     const queryParams = new URLSearchParams();

//     Object.entries({ ...reqData, status }).forEach(([key, value]) => {
//       if (Array.isArray(value)) {
//         value.forEach((item) => queryParams.append(key + "[]", item)); // Append array elements properly
//       } else {
//         queryParams.append(key, value);
//       }
//     });

//     if (queryParams.toString()) {
//       url += `&${queryParams.toString()}`;
//     }

//     let response = await fetch(url, requestOptions);
//     const isJson = response.headers.get("content-type")?.includes("application/json");
//     const data = isJson && (await response.json());

//     if (response.status === 200) {
//       return { res: data, error: null };
//     } else {
//       return { res: null, error: data };
//     }
//   } catch (error) {
//     console.error("There was an error!", error);
//     return { res: null, error: error };
//   }
// };
export const getTasksByUser = async (reqData = {}, status = 'non_completed=true',page=1 ) => {
  const authToken = localStorage.getItem("authToken");
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${authToken}`,
    },
  };

  try {
    let url = `${process.env.REACT_APP_USER_API_CLOUD_ENDPOINT}/v2/user/tasks?sort=due_date&page=${page}&${status}`
    if(status === 'non_completed=true'){
      url = `${process.env.REACT_APP_USER_API_CLOUD_ENDPOINT}/v2/user/tasks?sort=due_date&page=${page}&${status}`;
    }else{
      url = `${process.env.REACT_APP_USER_API_CLOUD_ENDPOINT}/v2/user/completed-tasks?sort=due_date&page=${page}`;
    }
    

    console.log("Requesting tasks with params:", reqData);

    // Convert reqData into query parameters manually
    const queryParams = new URLSearchParams();

    Object.entries(reqData).forEach(([key, value]) => {
      if (Array.isArray(value)) {
        value.forEach((item) => queryParams.append(key + "[]", item)); // Append array elements properly
      } else {
        queryParams.append(key, value);
      }
    });

    if (queryParams.toString()) {
      url += `&${queryParams.toString()}`;
    }

    let response = await fetch(url, requestOptions);
    const isJson = response.headers.get("content-type")?.includes("application/json");
    const data = isJson && (await response.json());

    if (response.status === 200) {
      return { res: data, error: null };
    } else {
      return { res: null, error: data };
    }
  } catch (error) {
    console.error("There was an error!", error);
    return { res: null, error: error };
  }
};


export const getJobsNum = async (id) => {
  const authToken = localStorage.getItem("authToken");
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${authToken}`,
    },
  };
  try {
    let response = await fetch(
      `${process.env.REACT_APP_USER_API_CLOUD_ENDPOINT}/v2/jobs/check-job-num/${id}`,
      requestOptions
    );
    const isJson = response.headers
      .get("content-type")
      ?.includes("application/json");
    const data = isJson && (await response.json());
    // console.log(response,data);
    if (response.status === 200) {
      return { res: data, error: null };
    } else {
      return { res: null, error: data };
    }
  } catch (error) {
    console.error("There was an error!", error);
    return { res: null, error: error };
  }
};

export const getJobsByFilter = async (filter) => {
  const authToken = localStorage.getItem("authToken");
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${authToken}`,
    },
  };
  try {
    let response = await fetch(
      `${process.env.REACT_APP_USER_API_CLOUD_ENDPOINT}/jobs/filter?${filter}`,
      requestOptions
    );
    const isJson = response.headers
      .get("content-type")
      ?.includes("application/json");
    const data = isJson && (await response.json());
    // console.log(response,data);
    if (response.status === 200) {
      return { res: data, error: null };
    } else {
      return { res: null, error: data };
    }
  } catch (error) {
    console.error("There was an error!", error);
    return { res: null, error: error };
  }
};

export const SearchJobs = async (data) => {
  const authToken = localStorage.getItem("authToken");
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${authToken}`,
    },
    body: JSON.stringify(data),
  };
  try {
    let response = await fetch(
      `${process.env.REACT_APP_USER_API_CLOUD_ENDPOINT}/v2/getjobsby`,
      requestOptions
    );
    const isJson = response.headers
      .get("content-type")
      ?.includes("application/json");
    const data = isJson && (await response.json());
    // console.log(response,data);
    if (response.status === 200) {
      return { res: data, error: null };
    } else {
      return { res: null, error: data };
    }
  } catch (error) {
    console.error("There was an error!", error);
    return { res: null, error: error };
  }
};

export const FilterJobs = async (data, query, type='job') => {
  const authToken = localStorage.getItem("authToken");
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${authToken}`,
    },
    body: JSON.stringify(data),
  };
  try {
    let response = await fetch(
      `${process.env.REACT_APP_USER_API_CLOUD_ENDPOINT}/v2/job/filter?type=${type}&${query}`,
      requestOptions
    );
    const isJson = response.headers
      .get("content-type")
      ?.includes("application/json");
    const data = isJson && (await response.json());
    // console.log(response,data);
    if (response.status === 200) {
      return { res: data, error: null };
    } else {
      return { res: null, error: data };
    }
  } catch (error) {
    console.error("There was an error!", error);
    return { res: null, error: error };
  }
};

export const getTasksByFilter = async (filter) => {
  const authToken = localStorage.getItem("authToken");
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${authToken}`,
    },
  };
  try {
    let response = await fetch(
      `${process.env.REACT_APP_USER_API_CLOUD_ENDPOINT}/tasks/filterbyfields?${filter}`,
      requestOptions
    );
    const isJson = response.headers
      .get("content-type")
      ?.includes("application/json");
    const data = isJson && (await response.json());
    console.log(response, data);
    if (response.status === 200) {
      return { res: data, error: null };
    } else {
      return { res: null, error: data };
    }
  } catch (error) {
    console.error("There was an error!", error);
    return { res: null, error: error };
  }
};

export const deleteJobs = async (data) => {
  const authToken = localStorage.getItem("authToken");
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${authToken}`,
    },
    body: JSON.stringify(data),
  };
  try {
    let response = await fetch(
      `${process.env.REACT_APP_USER_API_CLOUD_ENDPOINT}/jobs/bulkdelete`,
      requestOptions
    );
    const isJson = response.headers
      .get("content-type")
      ?.includes("application/json");
    const data = isJson && (await response.json());

    if (response.status === 200) {
      return { res: data, error: null };
    } else {
      return { res: null, error: data };
    }
  } catch (error) {
    console.error("There was an error!", error);
    return { res: null, error: error };
  }
};

export const deleteJob = async (id) => {
  const authToken = localStorage.getItem("authToken");
  const requestOptions = {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${authToken}`,
    },
  };
  try {
    let response = await fetch(
      `${process.env.REACT_APP_USER_API_CLOUD_ENDPOINT}/jobs/${id}`,
      requestOptions
    );
    const isJson = response.headers
      .get("content-type")
      ?.includes("application/json");
    const data = isJson && (await response.json());

    if (response.status === 200) {
      return { res: data, error: null };
    } else {
      return { res: null, error: data };
    }
  } catch (error) {
    console.error("There was an error!", error);
    return { res: null, error: error };
  }
};

export const updateJobs = async (res) => {
  const authToken = localStorage.getItem("authToken");
  const requestOptions = {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${authToken}`,
    },
    body: JSON.stringify(res?.dataObj),
  };
  try {
    let response = await fetch(
      `${process.env.REACT_APP_USER_API_CLOUD_ENDPOINT}/v2/jobs/${res?.job_id}`,
      requestOptions
    );
    const isJson = response.headers
      .get("content-type")
      ?.includes("application/json");
    const data = isJson && (await response.json());

    if (response.status === 200) {
      return { res: data, error: null };
    } else {
      return { res: null, error: data };
    }
  } catch (error) {
    console.error("There was an error!", error);
    return { res: null, error: error };
  }
};

export const createJobs = async (data) => {
  const authToken = localStorage.getItem("authToken");
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${authToken}`,
    },
    body: JSON.stringify(data),
  };
  try {
    let response = await fetch(
      `${process.env.REACT_APP_USER_API_CLOUD_ENDPOINT}/v2/create-job`,
      requestOptions
    );
    const isJson = response.headers
      .get("content-type")
      ?.includes("application/json");
    const data = isJson && (await response.json());
   
    if (response.status === 201) {
      return { res: data, error: null };
    } else {
      return { res: null, error: data };
    }
  } catch (error) {
    console.error("There was an error!", error);
    return { res: null, error: error };
  }
};

export const createInvoice = async (data) => {
  const authToken = localStorage.getItem("authToken");
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${authToken}`,
    },
    body: JSON.stringify(data),
  };
  try {
    let response = await fetch(
      `${process.env.REACT_APP_USER_API_CLOUD_ENDPOINT}/invoices`,
      requestOptions
    );
    const isJson = response.headers
      .get("content-type")
      ?.includes("application/json");
    const data = isJson && (await response.json());
    console.log(response, data);
    if (response.status === 201) {
      return { res: data, error: null };
    } else {
      return { res: null, error: data };
    }
  } catch (error) {
    console.error("There was an error!", error);
    return { res: null, error: error };
  }
};

export const getTaskStages = async () => {
  const authToken = localStorage.getItem("authToken");
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${authToken}`,
    },
  };
  try {
    let response = await fetch(
      `${process.env.REACT_APP_USER_API_CLOUD_ENDPOINT}/v2/taskstages`,
      requestOptions
    );
    const isJson = response.headers
      .get("content-type")
      ?.includes("application/json");
    const data = isJson && (await response.json());
    // console.log(response,data);
    if (response.status === 200) {
      return { res: data, error: null };
    } else {
      return { res: null, error: data };
    }
  } catch (error) {
    console.error("There was an error!", error);
    return { res: null, error: error };
  }
};

export const createTaskStage = async (data) => {
  const authToken = localStorage.getItem("authToken");
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${authToken}`,
    },
    body: JSON.stringify(data),
  };
  try {
    let response = await fetch(
      `${process.env.REACT_APP_USER_API_CLOUD_ENDPOINT}/v2/create-taskstage`,
      requestOptions
    );
    const isJson = response.headers
      .get("content-type")
      ?.includes("application/json");
    const data = isJson && (await response.json());

    if (response.status === 201) {
      return { res: data, error: null };
    } else {
      return { res: null, error: data };
    }
  } catch (error) {
    console.error("There was an error!", error);
    return { res: null, error: error };
  }
};

export const deleteTask = async (id) => {
  const authToken = localStorage.getItem("authToken");
  const requestOptions = {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${authToken}`,
    },
  };
  try {
    let response = await fetch(
      `${process.env.REACT_APP_USER_API_CLOUD_ENDPOINT}/v2/tasks/${id}`,
      requestOptions
    );
    const isJson = response.headers
      .get("content-type")
      ?.includes("application/json");
    const data = isJson && (await response.json());
  
    if (response.status === 200) {
      return { res: data, error: null };
    } else {
      return { res: null, error: data };
    }
  } catch (error) {
    console.error("There was an error!", error);
    return { res: null, error: error };
  }
};

export const getJobsByUser = async () => {
  const authToken = localStorage.getItem("authToken");
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${authToken}`,
    },
  };
  try {
    let response = await fetch(
      `${process.env.REACT_APP_USER_API_CLOUD_ENDPOINT}/v2/user/job-numbers`,
      requestOptions
    );
    const isJson = response.headers
      .get("content-type")
      ?.includes("application/json");
    const data = isJson && (await response.json());
    // console.log(response,data);
    if (response.status === 200) {
      return { res: data, error: null };
    } else {
      return { res: null, error: data };
    }
  } catch (error) {
    console.error("There was an error!", error);
    return { res: null, error: error };
  }
};


export const getSingleTask = async (id) => {
  const authToken = localStorage.getItem("authToken");
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${authToken}`,
    },
  };
  try {
    let response = await fetch(
      `${process.env.REACT_APP_USER_API_CLOUD_ENDPOINT}/v2/task/${id}`,
      requestOptions
    );
    const isJson = response.headers
      .get("content-type")
      ?.includes("application/json");
    const data = isJson && (await response.json());
    // console.log(response,data);
    if (response.status === 200) {
      return { res: data, error: null };
    } else {
      return { res: null, error: data };
    }
  } catch (error) {
    console.error("There was an error!", error);
    return { res: null, error: error };
  }
};

export const getStates = async () => {
    const authToken = localStorage.getItem("authToken");
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${authToken}`,
    },
  };
  try {
    let response = await fetch(
      `${process.env.REACT_APP_USER_API_CLOUD_ENDPOINT}/v2/states`,
      requestOptions
    );
    const isJson = response.headers
      .get("content-type")
      ?.includes("application/json");
    const data = isJson && (await response.json());
    // console.log(response,data);
    if (response.status === 200) {
      return { res: data, error: null };
    } else {
      return { res: null, error: data };
    }
  } catch (error) {
    console.error("There was an error!", error);
    return { res: null, error: error };
  }
}


export const getLocations = async () => {
    const authToken = localStorage.getItem("authToken");
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${authToken}`,
    },
  };
  try {
    let response = await fetch(
      `${process.env.REACT_APP_USER_API_CLOUD_ENDPOINT}/v2/locations`,
      requestOptions
    );
    const isJson = response.headers
      .get("content-type")
      ?.includes("application/json");
    const data = isJson && (await response.json());
    // console.log(response,data);
    if (response.status === 200) {
      return { res: data, error: null };
    } else {
      return { res: null, error: data };
    }
  } catch (error) {
    console.error("There was an error!", error);
    return { res: null, error: error };
  }
}

export const searchLocations = async (search) => {
    const authToken = localStorage.getItem("authToken");
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${authToken}`,
    },
  };
  try {
    let response = await fetch(
      `${process.env.REACT_APP_USER_API_CLOUD_ENDPOINT}/v2/locations/search?name=${search}`,
      requestOptions
    );
    const isJson = response.headers
      .get("content-type")
      ?.includes("application/json");
    const data = isJson && (await response.json());
    // console.log(response,data);
    if (response.status === 200) {
      return { res: data, error: null };
    } else {
      return { res: null, error: data };
    }
  } catch (error) {
    console.error("There was an error!", error);
    return { res: null, error: error };
  }
}

export const addLocations = async (locationName, stateId) => {
    const authToken = localStorage.getItem("authToken");
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${authToken}`,
    },
    body:JSON.stringify({ "name": locationName, "state_id": stateId })
  };
  try {
    let response = await fetch(
      `${process.env.REACT_APP_USER_API_CLOUD_ENDPOINT}/v2/locations`,
      requestOptions
    );
    const isJson = response.headers
      .get("content-type")
      ?.includes("application/json");
    const data = isJson && (await response.json());
    // console.log(response,data);
    if (response.status === 200) {
      return { res: data, error: null };
    } else {
      return { res: null, error: data };
    }
  } catch (error) {
    console.error("There was an error!", error);
    return { res: null, error: error };
  }
}

